(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-utils/socket/assets/javascripts/socket.js') >= 0) return;  svs.modules.push('/components/lb-utils/socket/assets/javascripts/socket.js');
'use strict';

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, e) { if ("object" != typeof t || !t) return t; var r; if ("undefined" != typeof Symbol && void 0 !== (r = t[Symbol.toPrimitive])) { var i = r.call(t, e || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === e ? String : Number)(t); }
const _svs$core = svs.core,
  socket = _svs$core.socket,
  log = _svs$core.log;
const logger = log.getLogger('lb-utils:socket');

const cidCounter = function () {
  let nextCid = 0;
  return () => nextCid++;
}();
class Socket extends React.Component {
  constructor() {
    var _this;
    super(...arguments);
    _this = this;
    _defineProperty(this, "state", {
      error: null
    });
    _defineProperty(this, "retryCount", 0);
    _defineProperty(this, "timeout", null);
    _defineProperty(this, "connected", false);
    _defineProperty(this, "cid", cidCounter());
    _defineProperty(this, "onSocketUpdate", function () {
      return _this.props.onUpdate(...arguments);
    });
    _defineProperty(this, "subscribe", () => {
      const _this$props = this.props,
        path = _this$props.path,
        sendInitialUpdate = _this$props.sendInitialUpdate,
        autoReconnect = _this$props.autoReconnect;
      socket.subscribe(path, this.onSocketUpdate, this, sendInitialUpdate, autoReconnect);
      this.connected = true;
    });
    _defineProperty(this, "reconnect", error => {
      const _this$props2 = this.props,
        onTimeout = _this$props2.onTimeout,
        path = _this$props2.path,
        socketSubscribeRetryDelay = _this$props2.socketSubscribeRetryDelay,
        maxSocketSubscribeRetryCount = _this$props2.maxSocketSubscribeRetryCount;
      if (error.path !== path) {
        return;
      }
      this.retryCount++;
      const logString = "Could not connect to socket, attempts: ".concat(this.retryCount, "/").concat(maxSocketSubscribeRetryCount, " code: ").concat(error.code, " msg: ").concat(error.message);
      socket.unsubscribe(path, this);
      if (this.retryCount < maxSocketSubscribeRetryCount) {
        this.timeout = setTimeout(this.subscribe, socketSubscribeRetryDelay * 1000);
        logger.info(logString);
      } else {
        this.connected = false;
        logger.warn(logString);
        onTimeout(error);
        this.setState({
          error: new Error('Could not establish connection to socket')
        });
      }
    });
    _defineProperty(this, "retryReconnect", () => {
      if (!this.connected) {
        this.startSubscription();
      }
    });
  }
  componentDidMount() {
    this.startSubscription(() => socket.on('cerror', this.reconnect, this));
  }
  componentDidUpdate(prevProps) {
    if (prevProps.path !== this.props.path) {
      this.connected = false;
      socket.unsubscribe(prevProps.path, this);
      this.startSubscription();
    }
  }
  componentWillUnmount() {
    socket.unsubscribe(this.props.path, this);
    clearTimeout(this.timeout);
    socket.off('cerror', this.reconnect);
  }
  startSubscription(cb) {
    this.setState({
      error: null
    });
    this.retryCount = 0;
    clearTimeout(this.timeout);
    cb && cb();
    this.subscribe();
  }
  render() {
    const children = this.props.children;
    return typeof children === 'function' ? children({
      error: this.state.error,
      retryReconnect: this.retryReconnect
    }) : children;
  }
}
_defineProperty(Socket, "defaultProps", {
  maxSocketSubscribeRetryCount: 5,
  onTimeout: () => {},
  sendInitialUpdate: true,
  socketSubscribeRetryDelay: 5
});
setGlobal('svs.components.lbUtils.socket.Socket', Socket);

 })(window);